// extracted by mini-css-extract-plugin
export default {"returnToLoginPage":"ReturnToLoginPage_returnToLoginPage__GxHti"};